import fetch from '../core/fetch';

export default {
    url(code) {
        return code ? 'https://my.matterport.com/show/?m=' + code : '';
    },
    
    validate(url) {
      /* try { */
        if( !url ) return {status: true, code: '', msg: ''};
        var match = url.match(/^(?:https?:\/\/)?(?:my\.matterport\.com\/show\/\?m=|matterport\.com\/discover\/space\/)([0-9a-z]{11,16})$/i);
        if( match === null ) return {status: false, code: '', msg: 'The Matterport URL entered is Invalid. It should have the form https://my.matterport.com/show/?m=XXXXXXXXXXX'};
        //let checkMatterportExists = this.checkMatterportExists(url);
        //if( !checkMatterportExists ) return {status: false, code: '', msg: 'The Matterport at the URL provided cannot be found. Please ensure you have published the Matterport.'};
        return {status: true, code: match[1], msg: ''};
      /* }
      catch( error ) {
          return false;
      } */
    },

    checkMatterportExists(url) {
        let xmlHttpReq = new XMLHttpRequest();
        xmlHttpReq.open("HEAD", url, false);
        xmlHttpReq.send(null);
        return xmlHttpReq.status == 200;
        
        /* var http = new XMLHttpRequest();
        http.open('HEAD', url);
        http.onreadystatechange = function() {
            if (this.readyState == this.DONE) {
                callback(this.status != 404);
            }
        };
        http.send();
        let t = 1; */
        /* try {
            const res = await fetch(url, {method: 'HEAD'});
            console.log(res);
            return res.status == 200;
        }
        catch( error ) {
            console.log(error);
            return false;
        } */
    }
}


// WEBPACK FOOTER //
// src/helpers/matterport.js